import { createUseStyles } from 'react-jss';

const styles = {
  fieldText: {
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 700 },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
